import { faArrowsSpin } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useConfig } from '@nexelem/config';
import { Button } from '@nexelem/components';
import { Link } from 'react-router-dom';
import { useCustomTranslation } from '../../../../hooks';
import { ROUTES } from '../../../../routes/config';
import { PlanView, useProductionPlanQueryParams } from '../hooks';

export const SimulationListButton = () => {
  const { tWrapper } = useCustomTranslation('products.simulationPlan');
  const { queryParams } = useProductionPlanQueryParams();
  const { modules } = useConfig();
  const isSimulationListEnabled = modules.production.simulationListView;

  if (!isSimulationListEnabled || queryParams.view !== PlanView.GANTT) {
    return null;
  }

  return (
    <Button
      component={Link}
      StartIcon={<FontAwesomeIcon icon={faArrowsSpin} />}
      to={ROUTES.plan.simulationListPath}
      variant="outlined"
    >
      {tWrapper('showSimulationList')}
    </Button>
  );
};
